<template>
  <div
    class="box">
    <span class="title">Plan Info</span>
    <div class="flex">
      <span
        v-if="!isSMEProduct"
        v-tooltip="detailData.company_language"
        class="icon icon-content"
      >
        <img
          :src="getOptionData('companySmallIcon', detailData.company_id).logo? getOptionData('companySmallIcon', detailData.company_id).logo: detailData.company_logo"
        >
      </span>
      <span
        v-if="!isSMEProduct"
        v-tooltip="detailData.class_language"
        class="icon icon-content"
      >
        <font-awesome-icon
          v-if="detailData.class_id"
          :icon="getOptionName('iconOptions', detailData.class_id)" />
      </span>
      <span
        class="plan-name hand text-decoration-none"
        @click="viewPlan">{{ detailData.plan }}</span>
    </div>
  </div>
</template>

<script>
import MixinOptions from '@/mixins/options'

export default {
  name: 'right-plan-info',
  mixins: [MixinOptions],
  props:{
    isSMEProduct:{
      type:Boolean,
      default:false
    },
    detailData:{
      type:Object,
      default:()=>({})
    }
  },
  methods:{
    viewPlan(){
      this.$emit('view')
    }
  }
}
</script>

<style scoped lang="scss">
.box{
  padding: 29.5px 0;
  border-bottom: 1px solid #D1D5DA;
  .status{
    color: #68C23A
  }
  .title {
    display: inline-block;
    margin-bottom: 10px;
    padding-top: 5px;
    font-size: 14px;
    font-weight: bold;
  }
  .icon{
    margin-right: 15px;
    img{
      height: 22px;
      width: 22px;
    }
  }
  .icon-content{
    height: 22px;
    width: 22px;
    border-radius: 5px;
    background-color: #E1E4E8;
    color: #6A737D;
    font-size: 14px;
    text-align: center;
    line-height: 22px;
  }
  .plan-name{
    color: #0366D6;
    font-family: Inter;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0;
  }
  .blue{
    color: #0366D6;
  }
}
</style>
